import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentSingleTabManager } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDstCVElf1n78kyqtk3JZ6twtjXeUcsU1g",
  authDomain: "openclose-e0689.firebaseapp.com",
  databaseURL: "https://openclose-e0689-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "openclose-e0689",
  storageBucket: "openclose-e0689.firebasestorage.app",
  messagingSenderId: "166680867513",
  appId: "1:166680867513:web:000144c6f4952e3e776168",
  measurementId: "G-EJ6DCEFM2Z"
};

const app = initializeApp(firebaseConfig);

let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentSingleTabManager() })
  });
} catch {
  db = getFirestore(app);
}

const auth = getAuth(app);

/* Realtime Database — utilisé pour onDisconnect (présence commerçant) */
const rtdb = getDatabase(app);

let analytics = null;
if (process.env.NODE_ENV === 'production' && firebaseConfig.measurementId) {
  analytics = getAnalytics(app);
}

export { db, auth, analytics, app, rtdb };
export default app;